
import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {
  SearchBarComponent,
  CheckboxComponent,
  ObjectCardComponent,
  ButtonComponent
} from '@mds/ui';
import { ProductEnrichmentApiService } from '@services/product-enrichment-api.service';
import { CommonDialogWrapperComponent } from '../common-dialog-wrapper/common-dialog-wrapper.component';
import { ProductData } from './enrich-product.model';
import {
  CommonCloseDialogType,
  CommonDialogButton
} from '../common-dialog-wrapper/common-dialog-wrapper.model';

@Component({
  selector: 'app-enrich-product',
  standalone: true,
  imports: [
    SearchBarComponent,
    FormsModule,
    ReactiveFormsModule,
    CheckboxComponent,
    ObjectCardComponent,
    CommonDialogWrapperComponent,
    ButtonComponent
],
  templateUrl: './enrich-product.component.html',
  styleUrls: ['./enrich-product.component.scss']
})
export class EnrichProductComponent {
  placeholder = 'Search products to enrich';
  searchText = new FormControl('');
  searchResults: any[] = [];
  selectedTilesRid: string[] = [];
  searchResultsCount = 0;

  headerText = 'Enrich Products';
  confirmButton: CommonDialogButton = { text: 'Enrich', type: 'primary' };
  cancelButton: CommonDialogButton = { text: 'Cancel', type: 'secondary' };

  submitButtonText = 'Enrich';
  selectAllText = 'Select all to import';
  deSelectAllText = 'Deselect all to import';

  constructor(
    public dialogRef: MatDialogRef<EnrichProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productEnrichmentApiService: ProductEnrichmentApiService
  ) {
    this.initSearch();
    this.performSearch(''); // Load initial enrichment suggestions
  }

  initSearch(): void {
    this.searchText.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((term: string) => {
        if (term && term.length >= 2) {
          this.performSearch(term);
        } else {
          this.searchResults = [];
          this.searchResultsCount = 0;
        }
      });
  }

  getFormattedData(res: ProductData[][]) {
    const resultArray: any[] = [];
    for (const item of res) {
      if (!item || !Array.isArray(item)) continue;

      const obj: any = {};

      for (const field of item) {
        switch (field.label) {
          case 'Name':
            obj.title = field.value;
            break;
          case 'Image':
            obj.image = field.value;
            break;
          case 'Price':
            obj.description = field.value;
            break;
          case 'Company':
            obj.enrich_company = field.value;
            break;
          case 'key':
            obj.key = field.value;
            obj.rid = field.value;
            break;
        }
      }

      if (Object.keys(obj).length > 0) {
        resultArray.push(obj);
      }
    }

    const formatted = [
      {
        label: 'Search Results',
        cards: resultArray
      }
    ];
    return formatted;
  }

  performSearch(term: string): void {
    if (!this.data?.rid) return;

    const resultArray: any[] = [];
    this.productEnrichmentApiService
      .getEnrichmentSearchResult(this.data.rid, term)
      .subscribe((res: ProductData[][]) => {
        this.searchResults = this.getFormattedData(res);
        this.searchResultsCount = resultArray.length;
      });
  }

  onDialogClose(event: CommonCloseDialogType) {
    if (event === CommonCloseDialogType.CONFIRM) {
      this.enrichProductSelect();
    } else {
      this.closeModal();
    }
  }

  updateTilesSelection(data: any): void {
    const index = this.selectedTilesRid.indexOf(data.rid);
    if (index >= 0) {
      this.selectedTilesRid.splice(index, 1);
    } else {
      this.selectedTilesRid.push(data.rid);
    }
  }

  enrichProductSelect(): void {
    this.dialogRef.close(this.selectedTilesRid);
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  selectAll(): void {
    this.selectedTilesRid = [];
    this.searchResults.forEach((group) => {
      group.cards.forEach((card: any) => {
        if (!this.selectedTilesRid.includes(card.rid)) {
          this.selectedTilesRid.push(card.rid);
        }
      });
    });
  }

  clearSelections(): void {
    this.selectedTilesRid = [];
  }
}
